import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'
import { cn } from '@/lib/utils'

type BackButtonProps = { to: string; label?: string; className?: string; onClick?: () => void }

export function BackButton({ to, label, className, onClick }: BackButtonProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const hasHistory = location.key !== 'default'
  const text = label ?? t('common.back')

  return (
    <button
      type="button"
      onClick={() => (onClick ? onClick() : void (hasHistory ? navigate(-1) : navigate(to)))}
      aria-label={text}
      title={text}
      className={cn(
        'flex size-9 shrink-0 items-center justify-center rounded-lg border bg-card text-muted-foreground shadow-xs transition-all hover:border-primary/30 hover:bg-primary/[0.06] hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 active:scale-95',
        className,
      )}
    >
      <ArrowLeft className="size-4" />
    </button>
  )
}
